"use client";

import { useState } from "react";
import { useSimulation } from "@/components/simulation-context";
import { useI18n } from "@/lib/i18n/hook";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Trash2 } from "lucide-react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

export default function SavedSimulationsList() {
  const {
    savedSimulations,
    //deleteSimulation,
    selectedSimulationIds,
    setSelectedSimulationIds,
  } = useSimulation();
  const { t } = useI18n();

  const [simulationToDelete, setSimulationToDelete] = useState<string | null>(
    null
  );

  // シミュレーションの選択状態を切り替える
  const toggleSimulationSelection = (id: string) => {
    setSelectedSimulationIds(
      selectedSimulationIds.includes(id)
        ? selectedSimulationIds.filter((simId) => simId !== id)
        : [...selectedSimulationIds, id]
    );
  };

  // 削除ダイアログを閉じる
  //const handleCloseDeleteDialog = () => {
  //  setSimulationToDelete(null);
  //};

  // シミュレーションを削除する
  //const handleDeleteSimulation = () => {
  //  if (simulationToDelete) {
  //    deleteSimulation(simulationToDelete)
  //    handleCloseDeleteDialog()
  //  }
  //}

  if (savedSimulations.length === 0) {
    return (
      <div className="text-center py-12">
        <h3 className="text-lg font-medium mb-2">
          {t("riskSimulation.noSavedSimulations")}
        </h3>
        <p className="text-muted-foreground">
          {t("riskSimulation.noSavedSimulationsDescription")}
        </p>
      </div>
    );
  }

  return (
    <div>
      <div className="mb-4">
        <p className="text-sm text-muted-foreground">
          {t("riskSimulation.selectSimulationsToCompare")}
        </p>
      </div>

      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-12">{t("common.select")}</TableHead>
            <TableHead>{t("riskSimulation.simulationName")}</TableHead>
            <TableHead>{t("common.dateTime")}</TableHead>
            <TableHead>{t("riskSimulation.monthlyInvestment")}</TableHead>
            <TableHead>{t("riskSimulation.investmentPeriod")}</TableHead>
            <TableHead>{t("riskSimulation.annualReturnRate")}</TableHead>
            <TableHead>{t("riskSimulation.targetAmount")}</TableHead>
            <TableHead>{t("common.statistics.medianFinalAsset")}</TableHead>
            <TableHead>{t("common.statistics.targetAchieveRate")}</TableHead>
            <TableHead className="w-12">{t("common.actions")}</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {savedSimulations.map((simulation) => (
            <TableRow key={simulation.id}>
              <TableCell>
                <Checkbox
                  checked={selectedSimulationIds.includes(simulation.id)}
                  onCheckedChange={() =>
                    toggleSimulationSelection(simulation.id)
                  }
                />
              </TableCell>
              <TableCell className="font-medium">{simulation.name}</TableCell>
              <TableCell>
                {simulation.date.toLocaleDateString()}{" "}
                {simulation.date.toLocaleTimeString()}
              </TableCell>
              <TableCell>
                {simulation.params.investmentAmount.toLocaleString()}
              </TableCell>
              <TableCell>
                {simulation.params.investmentPeriod}
                {t("common.years")}
              </TableCell>
              <TableCell>{simulation.params.returnRate}%</TableCell>
              <TableCell>
                {simulation.params.targetAmount.toLocaleString()}
              </TableCell>
              <TableCell>
                {Math.round(
                  simulation.result.statistics.median
                ).toLocaleString()}
              </TableCell>
              <TableCell>
                {Math.round(simulation.result.successRate)}%
              </TableCell>
              <TableCell>
                <Button
                  variant="ghost"
                  size="icon"
                  onClick={() => setSimulationToDelete(simulation.id)}
                >
                  <Trash2 className="h-4 w-4" />
                  <span className="sr-only">{t("common.delete")}</span>
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
